import { dangerColor, primaryColor } from "src/shared/colors";
import Toastify from "toastify-js";

const toast = (type: string, message: string) => {
  const instance = Toastify({
    text: message,
    stopOnFocus: true,
    close: true,
    backgroundColor: type === 'alert' ? dangerColor : primaryColor,
    style: {
      borderRadius: '5px',
    },
  })
  instance.showToast()
  // NOTE: data-turbo-temporary は属性の存在のみで判定される boolean attribute なので値は空文字でよい
  instance.toastElement?.setAttribute('data-turbo-temporary', '')
}

export function showSuccess(message: string) {
  toast('notice', message)
}

export function showError(message: string) {
  toast('alert', message)
}

// NOTE: Turbo.visit した後に toast を表示する場合はタイミングの問題で失敗することがあるので
// turbo:load イベントで確実に表示するようにする
export function showSuccessWithTurbo(message: string) {
  document.addEventListener('turbo:load', () => { showSuccess(message) }, { once: true })
}

window.showSuccess = showSuccess
window.showError = showError
